import { type RoleConstants } from "../state/userSlice";

const AI_TUTOR_ALLOWED_ROLES: RoleConstants[] = ["Admin", "Educator", "Tutor", "Parent"];

export function hasAITutorAccess(roles: RoleConstants[]): boolean {
  return roles.some((role) => AI_TUTOR_ALLOWED_ROLES.includes(role));
}
